export const BURNT_AREA_PATTERN_ID = 'foresight-burnt-area-hatch';

export const BURNT_AREA_STROKE_WIDTH = 1.5;
export const BURNT_AREA_FILL_COLOR = '#f2f2f2';
export const BURNT_AREA_FILL_OPACITY = 0.3;
const PATTERN_SIZE = 8;
const BURNT_AREA_STRIPE_COLOR = '#000000';

export function bindBurntAreaPathStyle(layer) {
  const applyToPaths = () => {
    if (!layer._map) {
      return;
    }
    _ensureBurntAreaHatchPattern(layer._map);
    _applyToPath(layer.getElement ? layer.getElement() : layer._path);
  };

  layer.on('add', applyToPaths);

  if (!layer._burntAreaStyleWrapped) {
    layer._burntAreaStyleWrapped = true;
    const originalSetStyle = layer.setStyle;
    layer.setStyle = function (style) {
      const result = originalSetStyle.call(this, style);
      applyToPaths();
      return result;
    };
  }
}

const _applyToPath = (path) => {
  if (!path) {
    return;
  }
  path.setAttribute('fill', `url(#${BURNT_AREA_PATTERN_ID})`);
  path.setAttribute('stroke', BURNT_AREA_STRIPE_COLOR);
  path.setAttribute('stroke-width', String(BURNT_AREA_STROKE_WIDTH));
  path.setAttribute('fill-opacity', '1');
};

/** Adds the Burnt Arena Hatch Pattern to the map so that it can be referenced and added to polygons. */
const _ensureBurntAreaHatchPattern = (map) => {
  if (!map || map._foresightBurntAreaPatternReady) {
    return;
  }

  const pane = map.getPane('overlayPane');
  if (!pane) {
    return;
  }

  const svg = pane.querySelector('svg.leaflet-zoom-animated') || pane.querySelector('svg');
  if (!svg) {
    return;
  }

  let defs = svg.querySelector('defs[data-foresight-burnt-area]');
  if (!defs) {
    defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
    defs.setAttribute('data-foresight-burnt-area', 'true');
    svg.insertBefore(defs, svg.firstChild);
  }

  if (defs.querySelector(`#${BURNT_AREA_PATTERN_ID}`)) {
    map._foresightBurntAreaPatternReady = true;
    return;
  }

  const pattern = document.createElementNS('http://www.w3.org/2000/svg', 'pattern');
  pattern.setAttribute('id', BURNT_AREA_PATTERN_ID);
  pattern.setAttribute('patternUnits', 'userSpaceOnUse');
  pattern.setAttribute('width', String(PATTERN_SIZE));
  pattern.setAttribute('height', String(PATTERN_SIZE));
  pattern.setAttribute('patternTransform', 'rotate(45)');

  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  rect.setAttribute('width', String(PATTERN_SIZE));
  rect.setAttribute('height', String(PATTERN_SIZE));
  rect.setAttribute('fill', BURNT_AREA_FILL_COLOR);
  rect.setAttribute('fill-opacity', String(BURNT_AREA_FILL_OPACITY));

  const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
  line.setAttribute('x1', '0');
  line.setAttribute('y1', '0');
  line.setAttribute('x2', '0');
  line.setAttribute('y2', String(PATTERN_SIZE));
  line.setAttribute('stroke', BURNT_AREA_STRIPE_COLOR);
  line.setAttribute('stroke-width', String(BURNT_AREA_STROKE_WIDTH));

  pattern.appendChild(rect);
  pattern.appendChild(line);
  defs.appendChild(pattern);
  map._foresightBurntAreaPatternReady = true;
};



// WEBPACK FOOTER //
// ./src/utils/leaflet_burnt_area_pattern.js